(ns nosco.tracking.track
  "A singleton class for handling all user tracking events.

   NOTE: Tracking is disabled by default. 2 settings decides this:
           1. Enabling `TRACKING-ENABLED` via closure-defines in shadow-cljs (eg. true for release builds only).
           2. When initializing (via main.cljs) the feature flags is checked.


   By having a centralized place for tracking user behaviour,
   we can easily exchange and experiment with different 3rd-party
   providers.

   Event names should be clean, concise and consistent (the 3 C's).
   Additional information should be provided as properties on the event.

   See: https://help.mixpanel.com/hc/en-us/articles/360033248932-How-to-Name-Your-Mixpanel-Data-
   Eg.:
    Action: Copy Channel
    Action: Create Idea
    View: Dashboard Page View
    View: Idea Page View"

  (:require
   ["mixpanel-browser" :as mixpanel]))

;; Disable tracking per default.
(goog-define ^boolean TRACKING-ENABLED false)

(defonce initialized (atom false))

(defn init
  "Initialize Mixpanel tracker.

   If is-enabled is false Mixpanel SDK will not send data to the Mixpanel API,
   ie. we tell Mixpanel that the user is opting out.
   NOTE: This must be done before any events are tracked."
  [is-enabled]
  (when-not @initialized
    (reset! initialized true)

    (if TRACKING-ENABLED
      (mixpanel/init "703c91dbf55a7d307a70c754b7fc5fb1"
                     ;; We turn tracking on and off via otp_in/opt_out,
                     ;; controlled by feature flags.
                     (clj->js {:opt_out_tracking_by_default (not is-enabled)
                               :secure_cookie true
                               :cross_subdomain_cookie false
                               :api_host "https://api-eu.mixpanel.com"}))
      (js/console.log "Tracking disabled. Events will be written to the console instead."))))

(defn- event
  "Track event"
  ([event-name]
   (event event-name nil))
  ([event-name props]
   (if TRACKING-ENABLED
     (mixpanel/track event-name (clj->js props))
     (js/console.log (str "Tracking(not sent): \"" event-name "\". Props: " (clj->js props))))))

(defn page-view
  "Track a page view.
   Optionally pass a map with properties."
  ([page-name]
   (page-view page-name nil))
  ([page-name props]
   (event (str "View: " page-name) props)))

(defn action
  "Track an action.
   Eg. copy-channel or a button click.
   Optionally pass a map with properties."
  ([action-name]
   (action action-name nil))
  ([action-name props]
   (event (str "Action: " action-name) props)))

(defn site-and-domain
  "Set the site title for the tracking.

   It will set the site title as a super property, meaning it will
   automatically be added to all events."
  [site-title domain]
  (if TRACKING-ENABLED
    (mixpanel/register (clj->js {:site-title site-title
                                 :domain     domain}))
    (js/console.log (str "Tracking(not-sent): Register " {:site-title site-title :domain domain}))))

(defn sign-in
  "Call when an existing user signs in"
  [{:keys [user-id is-admin]}]
  (action "sign in")
  (if TRACKING-ENABLED
    (do (mixpanel/identify user-id)
        (. mixpanel/people set (clj->js {:$name    user-id
                                         :is-admin is-admin}))
        (mixpanel/register (clj->js {:is-admin  is-admin})))
    (js/console.log (str "Tracking(not-sent): People Set " {:$name user-id :is-admin is-admin}))))

(defn sign-up
  "Call when a user signs up for the first time.

   NOTE: Do not call on user sign-in."
  []
  (action "sign up"))
